if (!customElements.get('swiper-component')) {
    class SwiperComponent extends HTMLElement {
        connectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }

            const self = this

            const container = this.initContainer()
            if (!container) return;

            const pagination = this.querySelector('.pagination');
            const { buttonPrev, buttonNext } = this.initButton() || {};

            const isCustomPagination = this.getAttribute('custom-pagination') === 'true';
            const defaultSlide = parseInt(this.getAttribute('default-slide')) || 0;

            const config = {
                slidesPerView: 'auto',
                autoHeight: true,
                initialSlide: defaultSlide,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                loop: false,
            };

            if (buttonPrev && buttonNext) {
                config.navigation = {
                    prevEl: buttonPrev,
                    nextEl: buttonNext
                };
            }

            if (isCustomPagination && pagination) {
                const activePaginationClass = this.getAttribute('active-pagination-class') || 'swiper-pagination-bullet-active';

                config.pagination = {
                    el: pagination,
                    type: 'custom',
                    clickable: true,
                    renderCustom: (swiper, current, total) => {
                        const bullets = Array.from(pagination.children);
                        bullets.forEach((bullet, index) => {
                            bullet.classList.toggle(activePaginationClass, index === swiper.activeIndex);
                        });
                        return pagination.innerHTML;
                    }
                };

                pagination.addEventListener('click', (e) => {
                    const child = Array.from(pagination.children).find(el => el.contains(e.target));
                    if (!child) return;
                    const index = Array.from(pagination.children).indexOf(child);
                    this.slideTo(index);
                });
            }
            else if (pagination) {
                config.pagination = {
                    el: pagination,
                    clickable: true
                };
            }

            self.swiper = new Swiper(container, config);
        }

        initContainer() {
            const wrapper = this.querySelector('.wrapper');
            if (!wrapper) return null;

            wrapper.classList.add('swiper-wrapper');

            Array.from(wrapper.children).forEach(child => {
                if (child.nodeType === 1) {
                    child.classList.add('swiper-slide');
                }
            });

            this.classList.add('swiper', 'swiper-container');
            this.style.display = 'block';
            return this;
        }

        initButton() {
            let buttonContainer = this;
            if (this.getAttribute('button-container-selector')) {
                buttonContainer = document.querySelector(this.getAttribute('button-container-selector'));
            }

            const buttonPrev = buttonContainer.querySelector('.button-prev');
            const buttonNext = buttonContainer.querySelector('.button-next');

            if (buttonPrev && buttonNext) {
                buttonPrev.classList.add('swiper-button-prev');
                buttonNext.classList.add('swiper-button-next');
                return { buttonPrev, buttonNext };
            }
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        slideTo(index, speed = 300, runCallbacks = true) {
            if (this.swiper) {
                this.swiper.slideTo(index, speed, runCallbacks);
            }
        }
    }

    customElements.define('swiper-component', SwiperComponent);
}
